import EntityImageActions from '../../entityImage/EntityImageActions';

const SiteImageActions = () => <EntityImageActions entityType="site" />;

export default SiteImageActions;
